import React from 'react';
import { X } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Cobrar por día te condena a ser un empleado eterno sin posibilidad de crecer.', 'Mirar la tabla del gremio no sirve porque no contempla los gastos ocultos de una obra real.', "Dar presupuestos 'de palabra' hace que el cliente abuse y te pida extras que terminás haciendo gratis por compromiso.", 'No ajustar por inflación hace que lo que cobraste al principio de la obra no alcance para comprar ni la mitad de las cosas al final.'];
  return <section className="py-20 px-4 bg-charcoal text-white relative" data-id="element-112">
      {/* Caution Tape Divider Top */}
      <div className="absolute top-0 left-0 w-full h-3 bg-caution-tape" data-id="element-113"></div>

      <div className="max-w-4xl mx-auto" data-id="element-114">
        <h2 className="font-heading font-bold text-4xl md:text-5xl mb-8 text-amber uppercase" data-id="element-115">
          Trabajar duro no alcanza si cobrás mal
        </h2>

        <div className="font-body text-lg md:text-xl space-y-6 mb-16 text-stone-300" data-id="element-116">
          <p data-id="element-117">
            En Argentina, cobrar "por lo que cobra el de al lado" es la forma
            más rápida de ir a la quiebra.{' '}
            <strong className="text-white" data-id="element-118">
              La inflación se come tus presupuestos en 15 días.
            </strong>
          </p>
          <p data-id="element-119">
            Si no sabés calcular el desgaste de tus herramientas, los fletes, el
            tiempo de compra de materiales y tu verdadero honorario por dar la
            cara ante el cliente, estás regalando tu salud.
          </p>
          <p className="text-amber-dark font-semibold text-xl md:text-2xl border-l-4 border-brick pl-4 py-2" data-id="element-120">
            Estás trabajando para pagar las cuentas de otros mientras tu familia
            sigue esperando que tu esfuerzo se note de verdad en el bolsillo.
          </p>
        </div>

        <div className="bg-stone-800 p-6 md:p-10 rounded-sm border-2 border-stone-700" data-id="element-121">
          <h3 className="font-heading font-bold text-2xl md:text-3xl mb-6 text-white uppercase" data-id="element-122">
            Por qué lo que venís haciendo no funciona:
          </h3>

          <ul className="space-y-4" data-id="element-123">
            {failedAttempts.map((attempt, index) => <li key={index} className="flex items-start gap-4" data-id="element-124">
                <div className="bg-brick p-1 rounded-sm mt-1 flex-shrink-0" data-id="element-125">
                  <X className="h-5 w-5 text-white" strokeWidth={3} data-id="element-126" />
                </div>
                <span className="font-body text-lg text-stone-200" data-id="element-127">
                  {attempt}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      {/* Caution Tape Divider Bottom */}
      <div className="absolute bottom-0 left-0 w-full h-3 bg-caution-tape" data-id="element-128"></div>
    </section>;
}